import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    auth.signOut().then(() => {
      navigate("/", { replace: true });
    });
  }, [navigate]);

  return <div style={{ padding: 24 }}>Logging out…</div>;
}
